import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import { AzavistaButtonModule } from '@azavista/components/button';
import { AzavistaFilterCriteriaModule } from '@azavista/components/filter-criteria';
import { AzavistaDurationModule } from '@azavista/components/duration';
import { EventsByTypeWidgetComponent } from './events-by-type/events-by-type-widget.component';
import { ApexchartsWrapperComponent } from './apexcharts-wrapper/apexcharts-wrapper.component';
import { ParticipantsByTypeWidgetComponent } from './participants-by-type/participants-by-type-widget.component';
import { ParticipantsByStageWidgetComponent } from './participants-by-stage/participants-by-stage-widget.component';
import { CountdownClockWidgetComponent } from './countdown-clock/countdown-clock-widget.component';
import { ObjectCountWidgetComponent } from './object-count/object-count-widget.component';
import { EventWaitingListWidgetComponent } from './event-waiting-list/event-waiting-list-widget.component';
import { ActivityParticipantGroupByStatusWidgetComponent } from './activity-participant-group-by-status/activity-participant-group-by-status-widget.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SalesByProductWidgetComponent } from './sales-by-product/sales-by-product-widget.component';
import { EmailCampaignDeliveryWidgetComponent } from './email-campaign-delivery/email-campaign-delivery.component';
import { SharedModule } from '../shared.module';
import { SalesByProductQuantityWidgetComponent } from './sales-by-product-quantity/sales-by-product-quantity.component';


@NgModule({
    declarations: [
        ApexchartsWrapperComponent,
        EventsByTypeWidgetComponent,
        EmailCampaignDeliveryWidgetComponent,
        ParticipantsByTypeWidgetComponent,
        ParticipantsByStageWidgetComponent,
        ActivityParticipantGroupByStatusWidgetComponent,
        CountdownClockWidgetComponent,
        ObjectCountWidgetComponent,
        EventWaitingListWidgetComponent,
        SalesByProductWidgetComponent,
        SalesByProductQuantityWidgetComponent,
    ],
    imports: [
        SharedModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        MatTooltipModule,
        TranslateModule,
        AzavistaButtonModule,
        AzavistaFilterCriteriaModule,
        AzavistaInputFieldModule,
        AzavistaDurationModule
    ]
})
export class WidgetsModule { }
